import moment from "moment";
import template from "./pProfitabilityViewManager.html";
import { slugify } from "../../utils/slugify";

export function pProfitabilityViewManagerDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pProfitabilityViewManagerController,
    controllerAs: 'pProfitabilityViewManager',
    bindToController: true
  };

  return directive;
}

class pProfitabilityViewManagerController {
  constructor($filter, $window, $location, $scope, $interval, Auth, Sort, Stats, DownloadFile, $translate, $rootScope, Bundle, $routeParams, Notes, ConnectionQuality) {
    'ngInject';


    this.QUALITY_PERCENTAGE_TIME_REPORTED_MONTHLY = 0;
    this.QUALITY_PERCENTAGE_OPPORTUNITY_TIME = 1;
    this.QUALITY_PERCENTAGE_WORKLOG_ENTRIES_ACCEPTED = 2;
    this.QUALITY_PERCENTAGE_WORKLOG_ENTRIES_ADDED_MANUALLY = 3;

    this.Auth = Auth;
    this.Stats = Stats;
    this.Sort = Sort;
    this.DownloadFile = DownloadFile;
    this.Bundle = Bundle;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$location = $location;
    this.$window = $window;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$translate = $translate;
    this.$filter = $filter;
    this.$routeParams = $routeParams;
    this.is360visible = false;
    this.isDE = localStorage.getItem('roedl-language').includes('de');
    this.div0 = "DIV/0";
    this.na = "N/A";
    this.averageRateState = 'collapsed';
    this.effectiveRateState = 'collapsed';
    this.effectiveRateValue = { min: null, max: null };
    this.averageRateValue = { min: null, max: null };
    this.effectiveRateHourlyCurrency = { min: null, max: null };
    this.averageRateHourlyCurrency = { min: null, max: null };
    this.effectiveRateHourlyEur = { min: null, max: null };
    this.averageRateHourlyEur = { min: null, max: null };
    this.clickOnCalendar = false;
    this.monthlyIncomes = null;
    this.currencyFromParam = $routeParams.currency;
    this.currencyRates = null;

    this.clientsSelectedAllColumns = true;
    this.groupsSelectedAllColumns = true;
    this.teamsSelectedAllColumns = true;

    this.cumulatedOvertimeAt = "";
    this.$scope.$watch(() => this.currencyRatio, () => this.setupCurrencyRate());
    this.$scope.$watch(() => this.allTablesCurrencyLocal, () => this.setupCurrencyName());
    this.init();


    this.qualityData = [
      {
        id: "percentageTimeReportedMonthly",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: false,
        state: "collapsed"
      },
      {
        id: "percentageOfOpportunityTime",
        name: Bundle.getBundleType() === 'roedl' ? this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME") :  this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME_NOT_ROEDL"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_OPPORTUNITY_TIME"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: false,
        state: "collapsed"
      },
      {
        id: "percentageWorklogsAccepted",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: false,
        state: "collapsed"
      },
      {
        id: "percentageWorklogsChanged",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED"),
        up: true,
        rangeMin: null,
        rangeMax: null,
        errorMin: false,
        errorMax: false,
        flipColors: true,
        state: "collapsed"
      }
    ];

    this.headersProfitability = [
      {
        name: this.$translate.instant("STATS.PROFITABILITY"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY_RATE")
      },
      {
        name: this.$translate.instant("STATS.AVERAGE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.AVERAGE")
      },
      {
        name: this.$translate.instant("STATS.EFFECTIVE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE")
      }
    ];

    this.headersTotalOvertimeBasic = [
      {
        name: this.$translate.instant("STATS.REPORTED_OVERTIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.REPORTED_OVERTIME")
      },
      {
        name: this.$translate.instant("STATS.ACCEPTED_OVERTIME_FOR_WHOLE_TEAM"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.ACCEPTED_OVERTIME_FOR_WHOLE_TEAM")
      },
      {
        name: this.$translate.instant("STATS.CUMULATED_OVERTIME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CUMULATED_OVERTIME"),
        appendCumulatedOvertimeAt: true
      }
    ];

    this.headersTeams = [
      {
        id: "teamName",
        name: this.$translate.instant("STATS.TEAM_NAME"),
        class: "table-info",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TEAM_NAME"),
        sort: "teamName",
        visible: true
      },
      {
        id: "percentageTimeReportedMonthly",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_TIME_REPORTED_MONTHLY"),
        sort: "percentageTimeReportedMonthly",
        visible: true
      },
      {
        id: "percentageOfOpportunityTime",
        name: Bundle.getBundleType() === 'roedl' ? this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME") :  this.$translate.instant("STATS.PERCENTAGE_OF_OPPORTUNITY_TIME_NOT_ROEDL"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_OPPORTUNITY_TIME"),
        sort: "percentageOfOpportunityTime",
        visible: true
      },
      {
        id: "percentageWorklogsAccepted",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED"),
        sort: "percentageWorklogsAccepted",
        visible: true
      },
      {
        id: "percentageWorklogsChanged",
        name: this.$translate.instant("STATS.PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED"),
        sort: "percentageWorklogsChanged",
        visible: true
      },
      {
        id: "internalTime",
        name: this.$translate.instant("STATS.INTERNAL_TIME"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.INTERNAL_TIME"),
        sort: "percentageOfInternalTime",
        visible: true
      },
      {
        id: "reportedOvertimeDuration",
        name: this.$translate.instant("STATS.REPORTED_OVERTIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.REPORTED_OVERTIME"),
        sort: "reportedOvertimeDuration",
        overtimeRelated: true,
        visible: true
      },
      {
        id: "acceptedOvertimeDuration",
        name: this.$translate.instant("STATS.ACCEPTED_OVERTIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.ACCEPTED_OVERTIME_FOR_WHOLE_TEAM"),
        sort: "acceptedOvertimeDuration",
        overtimeRelated: true,
        visible: true
      },
      {
        id: "cumulatedOvertimeDuration",
        name: this.$translate.instant("STATS.REMAINING_OVERTIME"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.CUMULATED_OVERTIME"),
        sort: "cumulatedOvertimeDuration",
        overtimeRelated: true,
        appendCumulatedOvertimeAt: true,
        visible: true
      },
      {
        id: "averageRateRateHourlyRate",
        name: this.$translate.instant("STATS.AVERAGE_HOURLY_RATE"),
        class: "table-currency",
        tooltip: this.$translate.instant("STATS.TOOLTIP.AVERAGE_HOURLY_RATE"),
        sort: ["averageRate.rate.hourlyRate.rate", "averageRate.noRate"],
        visible: true
      },
      {
        id: "averageProfitabilityRate",
        name: this.$translate.instant("STATS.AVERAGE_PROFITABILITY_RATE"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.AVERAGE_PROFITABILITY_RATE"),
        sort: ["averageRate.rate.ratio", "averageRate.noRate"],
        visible: true
      },
      {
        id: "turnover",
        name: this.$translate.instant("STATS.TURNOVER"),
        class: "table-turnover",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TURNOVER"),
        sort: "turnover",
        visible: true
      },
      {
        id: "timeForClients",
        name: this.$translate.instant("STATS.CLIENT_TIME"),
        class: "timeForClients",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TIME_FOR_CLIENTS"),
        sort: "timeForClients",
        visible: true
      },
      {
        id: "cost",
        name: this.$translate.instant("STATS.TEAM_COST"),
        class: "cost",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_COST"),
        sort: "cost",
        visible: true
      },
      {
        id: "margin",
        name: this.$translate.instant("STATS.PROFIT"),
        class: "margin",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_MARGIN"),
        sort: "margin",
        visible: true
      },
      {
        id: "hourlyRate",
        name: this.$translate.instant("STATS.EFFECTIVE_HOURLY_RATE"),
        class: "hourlyRate",
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE_HOURLY_RATE_FOR_TEAM"),
        sort: "effectiveRate.rate.hourlyRate.rate",
        visible: true
      },
      {
        id: "ratio",
        name: this.$translate.instant("STATS.EFFECTIVE_PROFITABILITY_RATE"),
        class: "ratio",
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE_PROFITABILITY_RATE_FOR_TEAM"),
        sort: "effectiveRate.rate.ratio",
        visible: true
      }
    ];

    this.headersGroups = [
      {
        id: "clientGroup",
        name: this.$translate.instant("STATS.CLIENT_GROUP"),
        class: "table-info",
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_GROUP"),
        sort: "clientGroup",
        visible: true
      },
      {
        id: "effectiveHourlyRate",
        name: this.$translate.instant("STATS.EFFECTIVE_HOURLY_RATE"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE_HOURLY_RATE"),
        sort: "effectiveRate.hourlyRate.rate",
        visible: true
      },
      {
        id: "effectiveProfitablityRate",
        name: this.$translate.instant("STATS.EFFECTIVE_PROFITABILITY_RATE"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.EFFECTIVE_PROFITABILITY_RATE"),
        sort: "effectiveRate.ratio",
        visible: true
      },
      {
        id: "turnover",
        name: this.$translate.instant("STATS.TURNOVER"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TURNOVER"),
        sort: "turnover",
        visible: true
      },
      {
        id: "totalCost",
        name: this.$translate.instant("STATS.TOTAL_COST"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_COST"),
        sort: "totalCost",
        visible: false
      },
      {
        id: "totalMargin",
        name: this.$translate.instant("STATS.TOTAL_MARGIN"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_MARGIN"),
        sort: "totalMargin",
        visible: false
      },
      {
        id: "timeSpent",
        name: this.$translate.instant("STATS.TIME_SPENT"),
        class: "table-date",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TIME_SPENT"),
        sort: "timeSpentDuration",
        visible: true
      },
      {
        id: "vaPercent",
        name: this.$translate.instant("STATS.VA_PERCENT"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.VA_PERCENT"),
        sort: "vaToNva",
        visible: true
      },
      {
        id: "mainTeam",
        name: this.$translate.instant("STATS.MAIN_TEAM"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.MAIN_TEAM"),
        sort: "mainTeam",
        visible: true
      },
      {
        id: "numberOfProcessProblems",
        name: this.$translate.instant("STATS.NR_OF_PROCESS_PROBLEMS"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.NR_OF_PROCESS_PROBLEMS"),
        sort: "numberOfProcessProblems",
        visible: true
      }
    ];

    this.headersClients = [
      {
        id: "clientName",
        name: this.$translate.instant("STATS.CLIENT_NAME"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_NAME"),
        class: "table-info",
        sort: "clientName",
        visible: true
      },
      {
        id: "clientGroup",
        name: this.$translate.instant("STATS.CLIENT_GROUP"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_GROUP_BELONGS"),
        class: "table-number",
        sort: "clientGroup",
        visible: true
      },
      {
        id: "effectiveRateHourlyRateRate",
        name: this.$translate.instant("STATS.EFFECTIVE_HOURLY_RATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_EFFECTIVE_HOURLY_RATE"),
        class: "table-number",
        sort: "effectiveRate.hourlyRate.rate",
        visible: true
      },
      {
        id: "effectiveRateRatio",
        name: this.$translate.instant("STATS.EFFECTIVE_PROFITABILITY_RATE"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_EFFECTIVE_PROFITABILITY_RATE"),
        class: "table-number",
        sort: "effectiveRate.ratio",
        visible: true
      },
      {
        id: "turnover",
        name: this.$translate.instant("STATS.TURNOVER"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TURNOVER"),
        sort: "turnover",
        visible: true
      },
      {
        id: "totalCost",
        name: this.$translate.instant("STATS.TOTAL_COST"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_COST"),
        sort: "totalCost",
        visible: false
      },
      {
        id: "totalMargin",
        name: this.$translate.instant("STATS.TOTAL_MARGIN"),
        class: "table-number",
        tooltip: this.$translate.instant("STATS.TOOLTIP.TOTAL_MARGIN"),
        sort: "totalMargin",
        visible: false
      },
      {
        id: "timeSpentDuration",
        name: this.$translate.instant("STATS.TIME_SPENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_TIME_SPENT"),
        class: "table-date",
        sort: "timeSpentDuration",
        visible: true
      },
      {
        id: "vaToNva",
        name: this.$translate.instant("STATS.VA_PERCENT"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_VA_PERCENT"),
        class: "table-number",
        sort: "vaToNva",
        visible: true
      },
      {
        id: "mainTeam",
        name: this.$translate.instant("STATS.MAIN_TEAM"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.CLIENT_MAIN_TEAM"),
        class: "table-number",
        sort: "mainTeam",
        visible: true
      },
      {
        id: "numberOfProcessProblems",
        name: this.$translate.instant("STATS.NR_OF_PROCESS_PROBLEMS"),
        tooltip: this.$translate.instant("STATS.TOOLTIP.NR_OF_PROCESS_PROBLEMS"),
        class: "table-number",
        sort: "numberOfProcessProblems",
        visible: true
      }
    ];


    this.headersGroupsF = this.headersGroups.concat({ class: "table-link" });
    this.headersClientsF = this.headersClients.concat({ class: "table-link" });

    this.state = "loading";
    this.stateOvertime = "loading";
    this.stateEmployeeOvertime = "loading";
    this.subTeamsAllSelected = false;

    this.isLeader = this.$location.path().startsWith('/stats/team');

    if (this.$routeParams.from && this.$routeParams.to) {
      localStorage.setItem(
        this.isLeader
          ? 'roedl-tl-date-pv'
          : 'roedl-m-date-pv'
        , this.$routeParams.from + '-' + this.$routeParams.to
      );
    }

    const storedDate = this.isLeader
      ? localStorage.getItem('roedl-tl-date-pv')
      : localStorage.getItem('roedl-m-date-pv');

    if (storedDate) {
      let date = storedDate.split("-"); //2018-07-2018-12 -> ['2018','07','2018','12']
      this.dateStartYear = date[0];
      this.dateStartMonth = date[1];
      this.dateEndYear = date[2];
      this.dateEndMonth = date[3];
    } else {
      this.dateStartYear = moment().subtract(1, "month").format("YYYY");
      this.dateStartMonth = moment().subtract(1, "month").format("MM");
      this.dateEndYear = moment().subtract(1, "month").format("YYYY");
      this.dateEndMonth = moment().subtract(1, "month").format("MM");
    }

    this.selectedDates = [this.dateStartMonth, this.dateStartYear, this.dateEndMonth, this.dateEndYear];

    this.updateDateRangeTrigger = (fromMonth, fromYear, toMonth, toYear) => {
      this.dateStartMonth = fromMonth;
      this.dateStartYear = fromYear;
      this.dateEndMonth = toMonth;
      this.dateEndYear = toYear;
      this.updateDateRange();
    };

    this.openProfitabilityRow = (name) => {
      if (this[name] == "collapsed") {
        this[name] = "shown";
      }
      else {
        this[name] = "in-transition";
        setTimeout(() => {
          this[name] = "collapsed";
          this.$scope.$digest(); // wtf? without it it seems so slow and dependant on mouse events
        }, 250);
      }
    };

    this.setRowState = (id, state) => {
      this.qualityData = this.qualityData.map(e => {
        return e.id == id ? { ...e, state: state } : e;
      });
    };

    this.openRow = (id) => {
      const row = this.qualityData.find(e => e.id == id);
      if (row.state == "collapsed") {
        this.setRowState(id, "shown");
      } else {
        this.setRowState(id, "in-transition");
        setTimeout(() => {
          this.setRowState(id, "collapsed");
          this.$scope.$digest(); // wtf? without it it seems so slow and dependant on mouse events
        }, 250);
      }
    };

    this.mapFormatingValue = {
      'effectiveRate': { beName: 'EffectiveHourlyRate', name: 'effectiveRateValue' },
      'averageRate': { beName: 'AverageHourlyRate', name: 'averageRateValue' },
      'percentageWorklogsChanged': { beName: 'WorklogsEntriesAddedManually', index: 3 },
      'percentageWorklogsAccepted': { beName: 'WorklogEntriesAccepted', index: 2 },
      'percentageOfOpportunityTime': { beName: 'OpportunityTime', index: 1 },
      'percentageTimeReportedMonthly': { beName: 'TimeReportedMonthly', index: 0 },
      'averageRateHourlyEur': { beName: 'AverageHourlyRateUniversal', name: 'averageRateHourlyEur' },
      'averageRateHourlyCurrency': { beName: 'AverageHourlyRateLocal', name: 'averageRateHourlyCurrency' },
      'effectiveRateHourlyEur': { beName: 'EffectiveHourlyRateUniversal', name: 'effectiveRateHourlyEur' },
      'effectiveRateHourlyCurrency': { beName: 'EffectiveHourlyRateLocal', name: 'effectiveRateHourlyCurrency' }
    };



    this.setColor = (__value, _valueMax, _valueMin, flip) => {
      const value = parseFloat(__value);
      const valueMax = parseFloat(_valueMax);
      const valueMin = parseFloat(_valueMin);
      const leftColor = flip ? "green" : "red";
      const rightColor = flip ? "red" : "green";

      if (!Number.isFinite(valueMax) && !Number.isFinite(valueMin) || !Number.isFinite(value)) return null;
      else if (Number.isFinite(valueMin) && Number.isFinite(valueMax)) {
        if (value <= valueMin) return leftColor;
        else if (value >= valueMax) return rightColor;
        else if (value > valueMin && value < valueMax) return "yellow";
      }
      else {
        if (Number.isFinite(valueMin)) {
          if (value <= valueMin) return leftColor;
          else return null;
        }
        else if (Number.isFinite(valueMax)) {
          if (value >= valueMax) return rightColor;
          else return null;
        }
      }
      return null;
    };

    const setFlagsAndHeaders = () => {
      this.overtimeManagement = this.user.preferences.featureFlags.some(f => f === "OvertimeManagement");
      this.view360FeatureFlag = this.user.preferences.featureFlags.some(f => f === "View360");
      this.overtimeApplicationsFlag = this.user.preferences.featureFlags.some(ff => ff === "OvertimeApplications");

      if (this.overtimeApplicationsFlag) {
        this.headersTotalOvertime = [
          ...this.headersTotalOvertimeBasic,
          {
            name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.APPLICATION_OVERTIME"),
          },
          {
            name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.ALLOCATED_APPLICATION_OVERTIME"),
            appendCumulatedOvertimeAt: true
          }
        ];

        this.headersTeams.splice(
          9,
          0,
          {
            id: "applicationOvertime",
            name: this.$translate.instant("OVERTIME.APPLICATION_OVERTIME"),
            class: "table-date",
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.APPLICATION_OVERTIME"),
            sort: "applicationOvertime",
            visible: false
          },
          {
            id: "allocatedApplicationOvertime",
            name: this.$translate.instant("OVERTIME.ALLOCATED_APPLICATION_OVERTIME"),
            class: "table-date",
            tooltip: this.$translate.instant("STATS.TOOLTIP.PROFITABILITY.ALLOCATED_APPLICATION_OVERTIME"),
            sort: "allocatedApplicationOvertime",
            visible: false,
            appendCumulatedOvertimeAt: true
          }
        );

      } else {
        this.headersTotalOvertime = [...this.headersTotalOvertimeBasic];
      }
    };

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        if (!this.user.preferences || !this.user.preferences.featureFlags) {
          this.Auth.setFeatureFlagsToLocaleStorage(this.user).then(newUserInfo => {
            this.user = newUserInfo;
            setFlagsAndHeaders();
          });
        } else {
          setFlagsAndHeaders();
        }

        this.is360visible = this.view360FeatureFlag && this.user.canAccess360View;

        const preferences = this.user.preferences || {};

        const mapPreferncesToTables = [
          {
            preferncesName: 'mvTablesFliterColumnsTeams',
            tableName: 'headersTeams'
          },
          {
            preferncesName: 'mvTablesFliterColumnsGroups',
            tableName: 'headersGroups'
          },
          {
            preferncesName: 'mvTablesFliterColumnsClients',
            tableName: 'headersClients'
          }
        ];

        mapPreferncesToTables.forEach( table => {
          if(this.user.preferences.hasOwnProperty(table.preferncesName)) {
            this[table.tableName] = this[table.tableName].map(el => {
              el.visible = this.user.preferences[table.preferncesName].indexOf(el.id) >= 0;
              return el;
            });
          }
        });

        this.clientsSelectedAllColumns = this.headersClients.every( c => c.visible);
        this.groupsSelectedAllColumns = this.headersGroups.every( c => c.visible);
        this.teamsSelectedAllColumns = this.headersTeams.every( c => c.visible);

        this.qualityTableHidden = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'qualityTable') ? preferences.pvManagerTables.find((t) => t.table == 'qualityTable').isHidden : false;
        this.profitabilityTableHidden = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'profitabilityTable') ? preferences.pvManagerTables.find((t) => t.table == 'profitabilityTable').isHidden : false;
        this.totalOvertimeTableHidden = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'totalOvertimeTable') ? preferences.pvManagerTables.find((t) => t.table == 'totalOvertimeTable').isHidden : false;
        this.teamsTableHidden = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'teamsTable') ? preferences.pvManagerTables.find((t) => t.table == 'teamsTable').isHidden : false;
        this.clientGroupsTableHidden = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'clientGroupsTable') ? preferences.pvManagerTables.find((t) => t.table == 'clientGroupsTable').isHidden : false;
        this.clientsTableHidden = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'clientsTable') ? preferences.pvManagerTables.find((t) => t.table == 'clientsTable').isHidden : false;
        this.teamsTableCurrencyLocal = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'teamsTable') ? preferences.pvManagerTables.find((t) => t.table == 'teamsTable').isLocal : true;
        this.clientGroupsTableCurrencyLocal = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'clientGroupsTable') ? preferences.pvManagerTables.find((t) => t.table == 'clientGroupsTable').isLocal : true;
        this.clientsTableCurrencyLocal = preferences.pvManagerTables && preferences.pvManagerTables.find((t) => t.table == 'clientsTable') ? preferences.pvManagerTables.find((t) => t.table == 'clientsTable').isLocal : true;
        this.allTablesCurrencyLocal = this.teamsTableCurrencyLocal;

        this.Stats.getSubordinateTeams().then(
          (success) => {
            this.subActual = success.data.filter(sub => !sub.archivedAt).sort((a, b) => a.name.localeCompare(b.name));
            this.subArchived = success.data.filter(sub => sub.archivedAt).sort((a, b) => a.name.localeCompare(b.name));
            this.subTeams = this.subActual.concat(this.subArchived).filter(team => this.user.teamId == "49a6dcff-c4e6-443e-9627-597070a68c8e" ? true : team.name != "Team Iterators").filter(team => !team.excludeFromProfitabilityReport);

            if (this.$routeParams.allTeams) {
              preferences.pvManagerSubTeams = this.subTeams.map(team => team.id);
            }

            let intersectionOfSubTeamsAndPreferences = preferences.pvManagerSubTeams && this.subTeams.filter(team => preferences.pvManagerSubTeams.indexOf(team.id) !== -1);
            if (!preferences.pvManagerSubTeams ||
              (preferences.pvManagerSubTeams && (preferences.pvManagerSubTeams.length == 0 || this.subTeams.length === preferences.pvManagerSubTeams.length) ||
                intersectionOfSubTeamsAndPreferences.length == 0)
            ) {
              this.subTeamsAllSelected = true;
              this.subTeamsId = this.subTeams.map(team => team.id);
              this.subTeams.map(team => team.selected = true);
            } else {
              if (this.$rootScope.subTeamsScope === undefined || this.$rootScope.subTeamsScope.length === 0)
                this.subTeamsId = intersectionOfSubTeamsAndPreferences.map(team => team.id);
              else
                this.subTeamsId = this.$rootScope.subTeamsScope;
              this.subTeams.map(team => {
                if (this.$rootScope.subTeamsScope !== undefined && this.$rootScope.subTeamsScope.includes(team.id)) {
                  team.selected = true;
                }
                else {
                  if (this.$rootScope.subTeamsScope === undefined && preferences.pvManagerSubTeams.find(id => id == team.id)) {
                    team.selected = true;
                  }
                }
              });
            }

            if (this.$routeParams.allTeams) {
              this.Auth.patchPreferences(preferences).then(
                () => {
                  this.refreshProfitabilityView();
                },
                (error) => {
                  this.state = "error";
                  this.error = error;
                }
              );
            } else {
              this.refreshProfitabilityView();
            }
          },
          (error) => {
            this.state = "error";
            this.error = error;
          }
        );

      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  setQualityDataValues() {
    if (!this.data) {
      return;
    }
    const keys = Object.keys(this.data);
    keys.forEach(key => {
      switch (key) {
        case 'percentageOfOpportunityTime':
          this.qualityData.find(el => el.id == key).value = `${(this.data.percentageOfOpportunityTime * 100).toFixed(2)}%`;
          break;
        case 'percentageWorklogsAccepted':
          this.qualityData.find(el => el.id == key).value = `${(this.data.percentageWorklogsAccepted * 100).toFixed(2)}%`;
          break;
        case 'percentageWorklogsChanged':
          this.qualityData.find(el => el.id == key).value = `${(this.data.percentageWorklogsChanged * 100).toFixed(2)}%`;
          break;
      }
    });
  }

  saveValue(rowId, type) {
    const rootEl = this.mapFormatingValue[rowId];
    var rangeMin;
    var rangeMax;

    if (rootEl.name) {
      rangeMin = Number.parseFloat(this[rootEl.name].min);
      rangeMax = Number.parseFloat(this[rootEl.name].max);

      if (!isNaN(rangeMin) && !isNaN(rangeMax)) {
        if (type === 'min' && rangeMin > rangeMax) {
          this[rootEl.name].max = rangeMin;
          rangeMax = rangeMin;
        }
        else if (type === 'max' && rangeMax < rangeMin) {
          this[rootEl.name].min = rangeMax;
          rangeMin = rangeMax;
        }
      }


      this.Stats.putProfitabilitySettings({
        lowerBound: rangeMin,
        upperBound: rangeMax,
        setting: rootEl.beName
      }
      );
    }
    else if (!isNaN(rootEl.index)) {
      rangeMin = Number.parseFloat(this.qualityData[rootEl.index].rangeMin);
      rangeMax = Number.parseFloat(this.qualityData[rootEl.index].rangeMax);

      if (!isNaN(rangeMin) && !isNaN(rangeMax)) {
        if (type === 'min' && rangeMin > rangeMax) {
          this.qualityData[rootEl.index].rangeMax = rangeMin;
          rangeMax = rangeMin;
        }
        else if (type === 'max' && rangeMax < rangeMin) {
          this.qualityData[rootEl.index].rangeMin = rangeMax;
          rangeMin = rangeMax;
        }
      }
      this.Stats.putProfitabilitySettings({
        lowerBound: rangeMin,
        upperBound: rangeMax,
        setting: rootEl.beName
      }
      );
    }
  }

  setupCurrencyRate(){
    if(this.$rootScope.setupRate !== undefined){
      this.currencyRatio = this.currentCurrency === 'EUR' && this.localCurrency !== 'EUR' ? this.$rootScope.setupRate.rate : 1;
      this.localToEurRatio = this.$rootScope.setupRate.rate;
    }
    this.currencyRate = 1/this.localToEurRatio;
  }

  setupCurrencyName(){
    this.isEuroExchange = !this.allTablesCurrencyLocal;
  }

  setCurrency(currency) {
    this.isEuroExchange =  currency === 'EUR';
    this.switchAllCurrencies();
  }

  refreshProfitabilityView() {
    this.state = "loading";
    this.stateOvertime = "loading";
    this.stateEmployeeOvertime = "loading";
    this.dataOvertime = {};


    this.Stats.getProfitabilityReportManager(this.dateStartYear + "-" + this.dateStartMonth, this.dateEndYear + "-" + this.dateEndMonth, this.subTeamsId).then(
      (success) => {
        this.data = this.deserializeProfitabilityData(success.data);
        this.monthlyIncomes = this.data.monthlyIncomes;
        this.setQualityDataValues();
        this.Stats.refreshCurrencyConversions().then(
          (success) => {
            if (this.currenciesError)
              this.currenciesError = false;
            
            if (this.data.averageRate.rate && this.data.averageRate.rate.hourlyRate.currency === 'EUR'){
              this.currencyRate = 1.0; 
              this.localToEurRatio = 1.0;
            } else {
              this.currencyRates = success.data;
              this.Auth.getCustomSetupExchangeRate().then(customSetupExchangeRate =>{
                if (customSetupExchangeRate.status !== 200) {
                  this.currencyRate = 1.0;
                  this.localToEurRatio = this.data.averageRate.rate ? this.currencyRates[this.data.averageRate.rate.hourlyRate.currency] : '';
                } else {
                  this.currencyRate = (1/customSetupExchangeRate.data.rate);
                  this.localToEurRatio = customSetupExchangeRate.data.rate;
                }

                if (
                  this.currencyFromParam
                  && this.currencyFromParam === 'EUR'
                  && this.data.averageRate.rate
                  && this.data.averageRate.rate.hourlyRate.currency !== 'EUR'
                ) {
                  this.setCurrency(this.currencyFromParam);
                  this.currencyFromParam = null;
                }
              });
          }}, (error) => {
            this.currencyRates = {};
            this.state = "error";
            this.error = error;
            this.currenciesError = true;
          });

        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.error = error;
      }
    );

    this.Stats.getProfitabilityOvertimesReportManager(this.dateStartYear + "-" + this.dateStartMonth, this.dateEndYear + "-" + this.dateEndMonth, this.subTeamsId).then(
      (success) => {
        this.stateOvertime = "loaded";
        const data = angular.copy(success.data);
        const dataOvertime = {
          ...data,
          teamSummary: data.teamsWithReportedTimeSummary.sort((a, b) => a.teamName.localeCompare(b.teamName))
        };
        this.cumulatedOvertimeAt = data.cumulatedOvertimeAt;
        this.dataOvertime = this.deserializeProfitabilityOvertimeData(dataOvertime);
        const overtimeKeys = Object.keys(this.dataOvertime);
        const overtimeKey = overtimeKeys.find(key => key == 'percentageTimeReportedMonthly');
        this.qualityData.find(el => el.id == overtimeKey).value = `${(this.dataOvertime.percentageTimeReportedMonthly * 100).toFixed(2)}%`;
        this.getEmployeesOvertimes();
        this.updateTeamsStorage();
      }, (error) => {
        this.stateOvertime = "error";
        this.error = error;
      }
    );
  }

  getEmployeesOvertimes() {
    this.Stats.getProfitabilityEmployeesOvertimesReportManager(this.dateStartYear + "-" + this.dateStartMonth, this.dateEndYear + "-" + this.dateEndMonth, this.subTeamsId).then(
      ({ data }) => {
        this.stateEmployeeOvertime = "loaded";
        const employeeOvertimes = angular.copy(data.employeeOvertimes).sort((a, b) => a.userName.split(' ').splice(-1)[0].localeCompare(b.userName.split(' ').splice(-1)[0]));

        let employeesByTeams = {};
        employeeOvertimes.map(employee => {
          const id = employee.teamId;
          if (!employeesByTeams[id]) {
            employeesByTeams[id] = [];
          }
          employeesByTeams[id].push(employee);
        });

        //hourly overtimes?
        if (Array.isArray(this.dataOvertime.teamSummary)) this.dataOvertime.teamSummary.map(team => {
          let employees = [];
          if (employeesByTeams[team.teamId]) {
            employees = angular.copy(employeesByTeams[team.teamId]).map(e => ({
              ...e,
              reportedOvertimeDuration: moment.duration(e.reportedOvertime).toJSON(),
              acceptedOvertimeDuration: moment.duration(e.acceptedOvertime).toJSON(),
              cumulatedOvertimeDuration: moment.duration(e.cumulatedOvertime).toJSON(),
              positionTypes: new Set(e.positionTypes)
            }));
          }

          team.employees = employees;
          return team;
        });
      }, (error) => {
        this.stateEmployeeOvertime = "error";
        this.error = error;
      }
    );
  }

  updateDateRange() {
    let start = this.dateStartYear + "-" + this.dateStartMonth;
    let end = this.dateEndYear + "-" + this.dateEndMonth;

    localStorage.setItem('roedl-m-date-pv', start + "-" + end);
    this.refreshProfitabilityView();
  }

  deserializeProfitabilityData(data) {
    var result = angular.copy(data);
    result.clientGroupManagerSummary && result.clientGroupManagerSummary.map((group) => {
      group.timeSpentDuration = moment.duration(group.timeSpent);
      group.totalMargin = group.totalMargin || 0;
      group.totalCost = group.totalCost || 0;
    });

    result.clientGroupNoDurationSummary = result.clientGroupNoDurationSummary.map((client) => {
      return {
        clientGroup: client.clientGroup,
        clientGroupId: client.clientGroupId,
        effectiveRate: {
          hourlyRate: {
            rate: "DIV/0",
            currency: result.effectiveRate.currency
          },
          ratio: "DIV/0"
        },
        mainTeam: client.mainTeam,
        timeSpent: "PT0S",
        timeSpentDuration: moment.duration(client.timeSpent),
        turnover: client.turnover,
        totalMargin: client.totalMargin || 0,
        totalCost: client.totalCost || 0
      };
    });

    result.clientGroupManagerSummaryAll = result.clientGroupManagerSummary.concat(result.clientGroupNoDurationSummary);

    result.clientWithTimeReportedSummary.map((client) => {
      client.timeSpentDuration = moment.duration(client.timeSpent);
      client.totalMargin = client.totalMargin || 0;
      client.totalCost = client.totalCost || 0;
    });

    result.clientWithNoTimeReportedSummary.map((client) => {
      client.effectiveRate = {
        hourlyRate: {
          rate: "DIV/0",
          currency: result.effectiveRate.currency
        },
        ratio: "DIV/0"
      };
      client.timeSpent = "PT0S";
      client.timeSpentDuration = moment.duration(client.timeSpent);
      client.totalMargin = client.totalMargin || 0;
      client.totalCost = client.totalCost || 0;
    });
    const clientWithNoTimeReportedSummaryButWithIncome = result.clientWithNoTimeReportedSummary.filter(c => c.totalIncome > 0);

    result.clientSummaryAll = result.clientWithTimeReportedSummary.concat(clientWithNoTimeReportedSummaryButWithIncome);
    result.clientSummaryAll.map(client => {
      if (client.additionalInfo) {
        client.clientNameWithAdditionalInfo = `(${client.additionalInfo}) ${client.clientName}`;
      } 
    });

    return result;
  }

  deserializeProfitabilityOvertimeData(data) {
    var result = angular.copy(data);
    // Duration - to proper sort
    result.teamSummary.map((team) => {
      const teamDetails = this.subTeams.find(sub => sub.id === team.teamId);
      team.teamId = teamDetails && teamDetails.id;
      team.isArchived = teamDetails && !!teamDetails.archivedAt;
      team.acceptedOvertimeDuration = moment.duration(team.acceptedOvertime);
      team.reportedOvertimeDuration = moment.duration(team.reportedOvertime);
      team.cumulatedOvertimeDuration = moment.duration(team.cumulatedOvertime);
      // overtime can be a negative value - from BE : "PT-12H-10M-30S" we want to display as -12:10:30
      // moment.duration("this strage format").toJSON() is the solution (before hms filter)
      team.acceptedOvertimeC = moment.duration(team.acceptedOvertime).toJSON();
      team.reportedOvertimeC = moment.duration(team.reportedOvertime).toJSON();
      team.cumulatedOvertimeC = moment.duration(team.cumulatedOvertime).toJSON();
      team.positionTypes = new Set(team.positionTypes);
    });
    result.acceptedOvertimeFilter = this.$filter("hms")(result.acceptedOvertime);
    result.reportedOvertimeFilter = this.$filter("hms")(result.reportedOvertime);
    result.cumulatedOvertimeFilter = this.$filter("hms")(result.cumulatedOvertime);
    result.applicationOvertimeFilter = this.$filter("hms")(result.applicationOvertime);
    result.allocatedApplicationOvertimeFilter = this.$filter("hms")(result.allocatedApplicationOvertime);
    return result;
  }

  showRow(headers, value) {
    return headers.find(e => {
      return e.id == value;
    }).visible;
  }

  showHeaderTeams(header) {
    let show = !header.overtimeRelated || (header.overtimeRelated && this.overtimeManagement);
    let eleFind = this.headersTeams.find(el => {
      return el.sort === header.sort;
    });
    return show && eleFind.visible;
  }

  showHeaderGroups(header) {
    let eleFind = this.headersGroups.find(el => {
      return el.id === header.id;
    });
    return eleFind.visible;
  }

  showHeaderClients(header) {
    let eleFind = this.headersClients.find(el => {
      return el.id === header.id;
    });
    return eleFind.visible;
  }

  selectAllSubTeams() {
    this.subTeams.forEach(c => {
      if (this.subTeamsAllSelected) {
        c.selected = true;
      } else {
        c.selected = false;
      }
    });
    this.updateTeamsStorage();
  }

  init() {
    this.Stats.getProfitabilitySettings().then(success => {
      success.data.map(value => {
        if (value.setting === 'EffectiveHourlyRate') {
          this.effectiveRateValue.min = value.lowerBound;
          this.effectiveRateValue.max = value.upperBound;
        }
        else if (value.setting === 'AverageHourlyRate') {
          this.averageRateValue.min = value.lowerBound;
          this.averageRateValue.max = value.upperBound;
        }
        else if (value.setting === 'WorklogsEntriesAddedManually') {
          this.qualityData[3].rangeMin = value.lowerBound;
          this.qualityData[3].rangeMax = value.upperBound;
        }
        else if (value.setting === 'WorklogEntriesAccepted') {
          this.qualityData[2].rangeMin = value.lowerBound;
          this.qualityData[2].rangeMax = value.upperBound;
        }
        else if (value.setting === 'OpportunityTime') {
          this.qualityData[1].rangeMin = value.lowerBound;
          this.qualityData[1].rangeMax = value.upperBound;
        }
        else if (value.setting === 'TimeReportedMonthly') {
          this.qualityData[0].rangeMin = value.lowerBound;
          this.qualityData[0].rangeMax = value.upperBound;
        }
        else if (value.setting === 'AverageHourlyRateLocal') {
          this.averageRateHourlyCurrency.min = value.lowerBound;
          this.averageRateHourlyCurrency.max = value.upperBound;
        }
        else if (value.setting === 'AverageHourlyRateUniversal') {
          this.averageRateHourlyEur.min = value.lowerBound;
          this.averageRateHourlyEur.max = value.upperBound;
        }
        else if (value.setting === 'EffectiveHourlyRateLocal') {
          this.effectiveRateHourlyCurrency.min = value.lowerBound;
          this.effectiveRateHourlyCurrency.max = value.upperBound;
        }
        else if (value.setting === 'EffectiveHourlyRateUniversal') {
          this.effectiveRateHourlyEur.min = value.lowerBound;
          this.effectiveRateHourlyEur.max = value.upperBound;
        }
      });
    });

    this.Auth.getCustomSetupExchangeRate().then(customSetupExchangeRate =>{
      this.$rootScope.setupRate = customSetupExchangeRate.data;
    });
  }

  startPickTeams() {
    this.dropdownOpened = !this.dropdownOpened;
    this.subTeamsCopy = angular.copy(this.subTeams);

    this.subTeams.forEach(team => {
      if (!team.selected) {
        team.selected = false;
      }
    });
    this.subTeamsCopy.forEach(team => {
      if (!team.selected) {
        team.selected = false;
      }
    });
    this.updateTeamsStorage();
    this.subTeamsHasChanged = false;
  }

  getProfitabilityForSubTeams() {
    this.dropdownOpened = false;

    this.subTeamsNumber = this.subTeams.reduce(((accum, curr) => curr.selected ? accum + 1 : accum), 0);
    for (let i = 0; i < this.subTeams.length; i++) {
      if (this.subTeams[i].selected != this.subTeamsCopy[i].selected)
        this.subTeamsHasChanged = true;
    }

    if (this.subTeamsHasChanged && this.subTeamsNumber > 0) {
      this.subTeamsId = this.subTeams.filter((team) => team.selected == true).map((team) => team.id);
      this.refreshProfitabilityView();
      this.Auth.getPreferences().then((preferences) => {
        var newPreferences = angular.copy(preferences);
        newPreferences.pvManagerSubTeams = this.subTeamsId;
        this.Auth.patchPreferences(newPreferences);
      });
    }
    this.updateTeamsStorage();
  }

  patchPreferences(tableHeadersName, preferncesName) {
    this.clientsSelectedAllColumns = this.headersClients.every( c => c.visible);
    this.groupsSelectedAllColumns = this.headersGroups.every(c => c.visible);
    this.teamsSelectedAllColumns = this.headersTeams.every(c => c.visible);

    this.Auth.getPreferences().then((preferences) => {
      var newPreferences = angular.copy(preferences);
      let arrayVisible = [];

      this[tableHeadersName].forEach(el => {
        if (el.visible) {
          arrayVisible.push(el.id);
        }
      });
      newPreferences[preferncesName] = arrayVisible;
      this.Auth.patchPreferences(newPreferences);
    });
  }

  downloadClientGroupExport(clientGroupId, clientGroupName) {
    this.setupCurrencyRate();
    this.state = "loading";
    const from = this.dateStartYear + "-" + this.dateStartMonth;
    const to = this.dateEndYear + "-" + this.dateEndMonth;
    this.Stats.getClientGroupSheet(from, to, this.subTeamsId, clientGroupId, this.currencyRate).then(res => {
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers('content-type'),
        `profitability-client-group-export_${from}-${to}-${slugify(clientGroupName)}.xlsx`
        );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  downloadClientExport(clientId, clientName) {
    this.setupCurrencyRate();
    this.state = "loading";
    const from = this.dateStartYear + "-" + this.dateStartMonth;
    const to = this.dateEndYear + "-" + this.dateEndMonth;
    this.Stats.getClientSheet(from, to, this.subTeamsId, clientId, this.currencyRate).then(res => {
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers('content-type'),
        `profitability-client-export_${from}-${to}-${slugify(clientName)}.xlsx`
        );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  downloadTeamExport(event, teamId, teamName) {
    this.setupCurrencyRate();
    event.stopPropagation(); // prevent details to roll/unroll
    this.state = "loading";
    const from = this.dateStartYear + "-" + this.dateStartMonth;
    const to = this.dateEndYear + "-" + this.dateEndMonth;
    this.Stats.getTeamSheet(from, to, teamId, this.currencyRate).then(res => {
      this.DownloadFile.downloadFromResponse(
        res,
        res.headers('content-type'),
        `profitability-team-export_${from}-${to}-${slugify(teamName)}.xlsx`
      );
      this.state = "loaded";
    }, () => {
      this.state = "error";
    });
  }

  go360View(type, name) {
    localStorage.setItem('roedl-m-teams-pv', this.subTeamsId.join(","));
    this.selectedDates = [this.dateStartMonth, this.dateStartYear, this.dateEndMonth, this.dateEndYear];
    this.$window.open(`/stats/management/360-view/${type}/${encodeURIComponent(name)}`, 'm360');
  }

  hideQualityTable() {
    this.qualityTableHidden = !this.qualityTableHidden;
    this.Stats.changePvManagerPreferences(['qualityTable'], 'isHidden', this.qualityTableHidden);
  }

  hideProfitabilityTable() {
    this.profitabilityTableHidden = !this.profitabilityTableHidden;
    this.Stats.changePvManagerPreferences(['profitabilityTable'], 'isHidden', this.profitabilityTableHidden);
  }

  hideTotalOvertimeTable() {
    this.totalOvertimeTableHidden = !this.totalOvertimeTableHidden;
    this.Stats.changePvManagerPreferences(['totalOvertimeTable'], 'isHidden', this.totalOvertimeTableHidden);
  }

  hideTeamsTable() {
    this.teamsTableHidden = !this.teamsTableHidden;
    this.Stats.changePvManagerPreferences(['teamsTable'], 'isHidden', this.teamsTableHidden);
  }

  hideClientGroupsTable() {
    this.clientGroupsTableHidden = !this.clientGroupsTableHidden;
    this.Stats.changePvManagerPreferences(['clientGroupsTable'], 'isHidden', this.clientGroupsTableHidden);
  }

  hideClientsTable() {
    this.clientsTableHidden = !this.clientsTableHidden;
    this.Stats.changePvManagerPreferences(['clientsTable'], 'isHidden', this.clientsTableHidden);
  }

  switchAllCurrencies() {
    this.allTablesCurrencyLocal = !this.allTablesCurrencyLocal;
    this.teamsTableCurrencyLocal = this.allTablesCurrencyLocal;
    this.clientGroupsTableCurrencyLocal = this.allTablesCurrencyLocal;
    this.clientsTableCurrencyLocal = this.allTablesCurrencyLocal;
    this.Stats.changePvManagerPreferences(['teamsTable', 'clientGroupsTable', 'clientsTable'], 'isLocal', this.allTablesCurrencyLocal);
  }

  switchTeamsTableCurrency() {
    this.teamsTableCurrencyLocal = !this.teamsTableCurrencyLocal;
    this.Stats.changePvManagerPreferences(['teamsTable'], 'isLocal', this.teamsTableCurrencyLocal);
  }

  switchClientGroupsTableCurrency() {
    this.clientGroupsTableCurrencyLocal = !this.clientGroupsTableCurrencyLocal;
    this.Stats.changePvManagerPreferences(['clientGroupsTable'], 'isLocal', this.clientGroupsTableCurrencyLocal);
  }

  switchClientsTableCurrency() {
    this.clientsTableCurrencyLocal = !this.clientsTableCurrencyLocal;
    this.Stats.changePvManagerPreferences(['clientsTable'], 'isLocal', this.clientsTableCurrencyLocal);
  }

  updateTeamsStorage() {
    this.$rootScope.subTeamsScope = this.subTeamsId;
  }

  exportClientsReport() {
    this.state = 'loading';

    this.Stats.getClientReport({from: `${this.dateStartYear}-${this.dateStartMonth}`, to: `${this.dateEndYear}-${this.dateEndMonth}`, teamId: this.subTeamsId}).then(
      (success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers("content-type"),
          `Aggregate clients report ${this.dateStartYear}-${this.dateStartMonth}_${this.dateEndYear}-${this.dateEndMonth}`
        );
        this.state = 'loaded';
      }, (error) => {
        this.state = "error";
        this.error = error;
        this.Notes.postNote({type: "error", error});
      }
    );
  }

  exportClientGroupsReport() {
    this.state = 'loading';

    this.Stats.getClientGroupsReport({from: `${this.dateStartYear}-${this.dateStartMonth}`, to: `${this.dateEndYear}-${this.dateEndMonth}`, teamId: this.subTeamsId}).then(
      (success) => {
        this.DownloadFile.downloadFromResponse(
          success,
          success.headers("content-type"),
          `Aggregate client groups report ${this.dateStartYear}-${this.dateStartMonth}_${this.dateEndYear}-${this.dateEndMonth}`
        );
        this.state = 'loaded';
      }, (error) => {
        this.state = "error";
        this.error = error;
        this.Notes.postNote({type: "error", error});
      }
    );
  }
}
